/**
 * The rates of the return method the RMA is moving onto, or why there are none. The hint reuses the
 * screen's class: this only ever renders inside that screen.
 */
import { observer } from "mobx-react";
import FontBody2 from "../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../../components/fonts/font-props";
import IconExclamation from "../../../../../../../../components/icons/icon-exclamation/icon-exclamation";
import Icon from "../../../../../../../../components/icons/icon/icon";
import { Note, NOTE_TYPE } from "../../../../../../../../components/note/note";
import ChangeShippingOptionStore from "../../../../../stores/rma-action-store/change-shipping-option-store";
import ShippingRateDropdown from "../../../shared/shipping-rate-dropdown/shipping-rate-dropdown";

const BALANCE_HINT = "Choosing a shipping option with different price won't update the RMA balance.";

const RATES_UNAVAILABLE_MESSAGE =
    "No shipping options are available for this return method. Try choosing a different return method.";

interface IProps {
    store: ChangeShippingOptionStore;
}

const ChangeShippingOptionRates: React.FC<IProps> = observer(({ store }) => {
    if (store.ratesFailed) {
        return <Note type={NOTE_TYPE.ERROR} body={RATES_UNAVAILABLE_MESSAGE} />;
    }

    const shippingRates = store.shippingRates;

    return (
        <>
            <ShippingRateDropdown
                rates={shippingRates.rates}
                selectedRate={shippingRates.selectedRate}
                onSelect={shippingRates.setSelectedRate}
                isLoading={store.isLoadingRates}
            />

            <div className="change-shipping-option-screen-hint">
                <Icon Component={IconExclamation} color="var(--color-neutral-3)" />
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>{BALANCE_HINT}</FontBody2>
            </div>
        </>
    );
});

export default ChangeShippingOptionRates;
